import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import LeadFormBar from "@/components/LeadFormBar";
import HeroSection from "@/components/HeroSection";

const WellnessSection = lazy(() => import("@/components/WellnessSection"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));
const AboutSection = lazy(() => import("@/components/AboutSection"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <LeadFormBar />
      <main>
        <HeroSection />
        <Suspense fallback={null}>
          <WellnessSection />
          <TestimonialsSection />
          <AboutSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
